import * as React from "react";
import { Text } from "@uikit";
import {
  getCourseDaysOfOperation,
  DayExtended,
  GrassType,
} from "@kalabo/golfsavers-common";

interface IProps {
  groupSizes: {
    min_pax: number;
    max_pax: number;
  };
  holes?: number;
  architect?: string;
  days_of_operation?: DayExtended;
  year_built?: string;
  grass_type?: GrassType[];
  type?: string;
}

const CourseInformation = ({
  groupSizes,
  holes,
  architect,
  days_of_operation,
  year_built,
  grass_type,
  type,
}: IProps) => {
  const getGroupSizeText = () => {
    if (!groupSizes) return null;
    if (!groupSizes?.min_pax && !groupSizes?.max_pax) return null;
    if (groupSizes?.min_pax === 1 && groupSizes?.max_pax === 4) {
      return "*Single players may be grouped with other golfers.";
    }
    if (groupSizes?.min_pax > 1 && groupSizes?.max_pax === 4) {
      return null;
    }

    if (groupSizes?.min_pax > 1 && groupSizes?.max_pax > 4) {
      return "*Max group size may vary by day of week.";
    }

    if (groupSizes?.min_pax === 1 && groupSizes?.max_pax > 4) {
      return "*Single players may be grouped with other golfers. Max group size may vary by day of week.";
    }
    return null;
  };

  return (
    <div className=" border-t border-grey3 pt-10 flex flex-col">
      <Text
        element="h2"
        size={21}
        weight="semibold"
        className="mb-[30px]"
        color="black"
      >
        Course Info
      </Text>

      <Text
        element="h3"
        size={17}
        leading={1.3}
        weight="semibold"
        className="mb-[20px]"
        color="black90"
      >
        Key Facts
      </Text>

      <div className="flex flex-col sm:flex-row gap-4 w-full">
        <div className="flex flex-col w-full sm:w-1/2  gap-x-6 gap-y-4">
          <CourseData label="Holes" text={String(holes)} />

          {year_built && (
            <CourseData label="Established" text={String(year_built)} />
          )}

          {days_of_operation && (
            <CourseData
              label="Availability"
              text={String(getCourseDaysOfOperation(days_of_operation))}
            />
          )}

          <CourseData
            label={`Group Size`}
            text={`${groupSizes.min_pax === 0 ? 1 : groupSizes.min_pax} - ${
              groupSizes.max_pax === 0 ? 4 : groupSizes.max_pax
            } players${getGroupSizeText() ? "*" : ""}`}
          />
        </div>
        <div className="flex flex-col w-full sm:w-1/2  gap-x-6 gap-y-4">
          {type && <CourseData label="Type" text={String(type)} />}

          {architect && (
            <CourseData label="Designer" text={String(architect)} />
          )}

          {grass_type && grass_type.length > 0 ? (
            grass_type.map((grass: GrassType, gIdx: any) => (
              <CourseData
                key={gIdx}
                label={grass.grass_location}
                text={String(grass.grass_type)}
              />
            ))
          ) : (
            <>
              <CourseData label="Fairways" text="Unknown" />
              <CourseData label="Greens" text="Unknown" />
            </>
          )}
        </div>
      </div>
      <Text size={11} leading={1.3} color="black60" className="mt-4">
        {getGroupSizeText()}
      </Text>
    </div>
  );
};

interface ICourseDataProps {
  label: string;
  text: string;
}

const CourseData = ({ label, text }: ICourseDataProps) => {
  return (
    <div className="flex ">
      <div className="w-1/3">
        <Text size={15} color="black60" leading={1.5}>
          {label}
        </Text>
      </div>
      <div className="w-2/3">
        <Text size={15} color="black90" leading={1.5} className="mb-1">
          {text}
        </Text>
      </div>
    </div>
  );
};

export default CourseInformation;
